import { useContext, useEffect } from 'react';
import {
  LoaderContext,
  LoaderDispatchContext,
} from 'src/contexts/loader-context';

export function useLoader() {
  return useContext(LoaderContext);
}

export function useLoaderFetchingDispatch(isFetching: boolean) {
  const { dispatch } = useContext(LoaderDispatchContext);
  useEffect(() => {
    if (dispatch === null) {
      return;
    }

    dispatch({ type: 'set', payload: { isFetching } });
  }, [dispatch, isFetching]);
}

export default useLoader;
